import "./ApplicationHub.css";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Card, Flex, Grid, Text } from "@kui/foundations-react";
import { LayoutGrid } from "@nv-brand-assets/react-icons-inline";

function ApplicationHub({ items, ClickEvent }) {
  const [apps, setApps] = useState([]);

  useEffect(() => {
    if (items.length) {
      setApps(items);
    }
  }, [items]);

  return (
    <Flex direction="col" gap="4" className="application-container">
      {/* <Flex align="center" gap="1">
        <LayoutGrid variant="fill" style={{ width: 24, height: 24 }} />
        <Text asChild kind="body/semibold/xl">
          <h2>Applications</h2>
        </Text>
      </Flex> */}

      <Grid cols={{ sm: 1, md: 2, lg: 3 }} gap="4">
        {apps.map((item) => (
          <Card key={item.applicationname} asChild interactive>
            <a
              href={item.applicationurl}
              onClick={ClickEvent(item.applicationurl, item.applicationname)}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Flex direction="col" gap="4">
                <Flex align="center" gap="2">
                  <img
                    className="application-card-icon"
                    src={item.applicationicon}
                    alt=""
                  />
                  <Text kind="label/bold/md">{item.applicationname}</Text>
                </Flex>
                <Text kind="body/regular/md">{item.applicationdescription}</Text>
              </Flex>
            </a>
          </Card>
        ))}
      </Grid>
    </Flex>
  );
}
ApplicationHub.defaultProps = {
  items: [],
};

ApplicationHub.propTypes = {
  items: PropTypes.array,
  ClickEvent: PropTypes.func,
};

export default React.memo(ApplicationHub);
